import { render, staticRenderFns } from "./addFunction.vue?vue&type=template&id=83a7bf48&lang=pug&"
import script from "./addFunction.vue?vue&type=script&lang=js&"
export * from "./addFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports